import { useNavigate } from 'react-router-dom'
import { useTranslation } from '../../i18n/useTranslation'
import { useAuth } from '../../contexts/AuthContext'
import { QuickActionButton } from '../ui'

export default function Preferences() {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { user } = useAuth()

  const isCoach = user?.hasTrainees

  return (
    <div className="p-5">
      <header className="mb-6">
        <h1 className="text-3xl font-bold mb-2">⚙️ {t.preferences.title}</h1>
        <p className="text-sm opacity-70">{t.preferences.subtitle}</p>
      </header>

      <section className="space-y-3">
        <QuickActionButton
          icon="👤"
          title={t.preferences.userProfile.title}
          description={t.preferences.userProfile.description}
          onClick={() => navigate('/my-profile')}
        />
        <QuickActionButton
          icon="🔔"
          title={t.preferences.notifications.title}
          description={t.preferences.notifications.description}
          onClick={() => navigate('/notifications-settings')}
        />
        <QuickActionButton
          icon="📅"
          title={t.preferences.trainingSchedule.title}
          description={t.preferences.trainingSchedule.description}
          onClick={() => navigate('/training-schedule')}
        />
        {isCoach && (
          <QuickActionButton
            icon="📝"
            title={t.preferences.training.templates.title}
            description={t.preferences.training.templates.description}
            onClick={() => navigate('/templates')}
          />
        )}
        <QuickActionButton
          icon="💎"
          title={t.subscription.mySubscription}
          description={t.subscription.manageDescription}
          onClick={() => navigate('/subscription')}
        />
        <QuickActionButton
          icon="🛠️"
          title={t.preferences.support.title}
          description={t.preferences.support.description}
          onClick={() => navigate('/support', { state: { fromPath: '/preferences' } })}
        />
      </section>
    </div>
  )
}
